@if (operationSegmentSpec$ | async; as operationSegmentSpec) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: operationSegmentSpec }"
          >
          </ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: operationSegmentSpec }"
          >
          </ng-template>
        </mat-toolbar>
      }
    </div>
    <elder-single-pane-wrapper class="flex">
      <elder-pane-header>
        <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
        <elder-pane-actions>
          <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
            <mat-icon>save</mat-icon>
          </button>
        </elder-pane-actions>
      </elder-pane-header>
      <elder-pane-content>
        <form #mainFrm="ngForm" class="flex layout-row gap-xl">
          <div class="flex layout-col">
            <elder-pane-subtitle>{{ 'processing.title' | translate }}</elder-pane-subtitle>
            @if (operationSegmentSpec.materialMappingSpec; as mappingSpec) {
              <div class="layout-col gap-md">
                <elder-label-input
                  name="consumptionMaterialPaths"
                  label="{{ 'bom.cBom' | translate }} {{ 'bom.component-paths' | translate }} ({{
                    'context.material' | translate
                  }})"
                  [(value)]="mappingSpec.consumptionMaterialPaths"
                >
                </elder-label-input>
                <elder-label-input
                  name="finishedMaterialPaths"
                  label="{{ 'bom.fBom' | translate }} {{ 'bom.component-paths' | translate }} ({{
                    'context.material' | translate
                  }})"
                  [(value)]="mappingSpec.finishedMaterialPaths"
                >
                </elder-label-input>
                <!-- Feature flag-->
                <mat-checkbox [(ngModel)]="mappingSpec.retainBomNames">{{
                  'temp.retain-bom-names' | translate
                }}</mat-checkbox>
              </div>
            }
          </div>
        </form>
      </elder-pane-content>
    </elder-single-pane-wrapper>
  </div>
}

<ng-template #header let-operationSegmentSpec>
  @if (creationMode) {
    <span>
      {{ 'operations.new' | translate }}
    </span>
  } @else {
    <elder-header
      [header]="'operations.operation' | translate"
      [subheader]="'ID: ' + operationSegmentSpec.action"
    >
    </elder-header>
  }
</ng-template>
